import React, { useEffect, useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import MultiSelectField from "../../../components/Fields/MultiSelectField";
import NumberField from "../../../components/Fields/NumberField";
import SwitchField from "../../../components/Fields/SwitchField";
import TextboxField from "../../../components/Fields/TextboxField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import UserDefinedFieldSelectListItemModel from "../../../models/UserDefinedFieldSelectListItemModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    userDefinedFieldSelectlistOptionId: number
    userDefinedFieldTypeId: number
}

const AddUserDefinedFiedSelectlistOptionPopup: React.FC<Props> = ({ show, onHide, userDefinedFieldSelectlistOptionId, userDefinedFieldTypeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const [formData, setFormData] = useState<UserDefinedFieldSelectListItemModel>();

    const productCategories = useSelectListOptions('api/v1/selectlist/ProductCategoryNameTrees?activeOnly=true');

    useEffect(() => {
        getFormData()
    }, [])

    function getFormData() {
        DataService
            .get<UserDefinedFieldSelectListItemModel>(`api/v1/UserDefinedFieldSelectListItems/${userDefinedFieldSelectlistOptionId}`)
            .then(response => { setFormData(response); })
            .catch(e => handleException(e));
    }

    function submit() {
        if (formData) {
            DataService
                .update<UserDefinedFieldSelectListItemModel>(`api/v1/UserDefinedFieldSelectListItems`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'value', label: 'Value', labelSize: 3, validationRules: [{ type: 'isRequired' }, { type: 'isMaxLength', maxLength: 50 }] },
            { name: 'text', label: 'Text', labelSize: 3, validationRules: [{ type: 'isMaxLength', maxLength: 50 }] },
            { name: 'sortOrder', label: 'Sort order', labelSize: 3 },
            { name: 'isActive', label: 'Is active', labelSize: 3 },
            { name: 'productCategoryIds', label: 'Product categories', labelSize: 3 },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Edit selectlist option'} >
            <Popup.Body>
                <TextboxField {...getFieldProps('value')} />
                <TextboxField {...getFieldProps('text')} />
                <NumberField {...getFieldProps('sortOrder')} />
                <SwitchField {...getFieldProps('isActive')} />
                {userDefinedFieldTypeId == 1 && < MultiSelectField {...getFieldProps('productCategoryIds')} options={productCategories} />}
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddUserDefinedFiedSelectlistOptionPopup;